import { create } from 'zustand';

// Load state function (similar to water store)
const loadState = () => {
  try {
    const savedState = localStorage.getItem('cameraParams');
    return savedState ? JSON.parse(savedState) : undefined;
  } catch (err) {
    console.error("Could not load camera state", err);
    return undefined;
  }
};

const initialState = {
  fov: 119,
  minDistance: 8.4,
  maxDistance: 50,
};

const useCameraStore = create((set) => ({
  ...(loadState() || initialState),

  setFov: (val) => set({ fov: Math.max(10, Math.min(120, parseFloat(val) || 50)) }), // Clamp FOV
  setMinDistance: (val) => set({ minDistance: Math.max(0.1, parseFloat(val) || 1) }),
  setMaxDistance: (val) => set({ maxDistance: Math.max(1, parseFloat(val) || 50) }),

}));

// Save state function (similar to water store)
export const saveCameraState = () => {
  try {
    const stateToSave = useCameraStore.getState();
    const paramsOnly = {
      fov: stateToSave.fov,
      minDistance: stateToSave.minDistance,
      maxDistance: stateToSave.maxDistance,
    };
    localStorage.setItem('cameraParams', JSON.stringify(paramsOnly));
    console.log("Camera params saved to localStorage");
  } catch (err) {
    console.error("Could not save camera state", err);
  }
};


export default useCameraStore; 